import apiClient from '../../../api/client';
import { API_ENDPOINTS } from '../../../constants/apiEndpoints';
import { MAINTENANCE_SETTING_KEY } from '../models';

const MAINTENANCE = API_ENDPOINTS.MAINTENANCE;
const ADMIN_SETTINGS = API_ENDPOINTS.ADMIN_SETTINGS;

/**
 * Maintenance API
 * Reads the public maintenance status (no auth) and toggles the
 * MAINTENANCE_MODE setting via the admin settings endpoint.
 */
export const maintenanceApi = {
    async getStatus() {
        const response = await apiClient.get(MAINTENANCE.STATUS);
        return {
            enabled: Boolean(response.data?.enabled),
            message: response.data?.message || null,
        };
    },

    async setStatus(enabled) {
        const response = await apiClient.put(
            ADMIN_SETTINGS.UPDATE,
            { value: enabled ? 'enabled' : 'disabled' },
            { key: MAINTENANCE_SETTING_KEY },
        );
        return response.data;
    },
};

export default maintenanceApi;
